import { createRouter, createWebHistory } from "vue-router";
import AppNavigation from "./shared/layout/AppNavigation.vue";
import guest from "./shared/router/middleware/guest";
import auth from "./shared/router/middleware/auth";
import store from "./store";
import middlewarePipeline from "./shared/router/middlewarePipeline";

const routes = [
  {
    path: "/",
    name: "navigation",
    component: AppNavigation,
    meta: {
      middleware: [auth],
    },
  },
  {
    path: "/metrics",
    name: "metrics",
    component: () => import("./pages/dashboard/Dashboard.page.vue"),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: "/metrics/subscriptions",
    name: "metrics-subscriptions",
    component: () => import("./pages/subscription-stats/SubscriptionStats.page.vue"),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./pages/login/Login.page.vue"),
    meta: {
      middleware: [guest],
    },
  },

  {
    path: "/user",
    name: "users",
    component: () => import("./pages/users/Users.page.vue"),
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/firmware",
    name: "firmware",
    component: () => import("./pages/firmware/Firmware.page.vue"),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: "/shared-practice",
    name: "shared-practice",
    component: () => import("./pages/shared-practice/SharedPractice.page.vue"),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: "/news-feed",
    name: "news-feed",
    component: () => import("./pages/news-feed/NewsFeed.page.vue"),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: "/mass-mailing",
    name: "mass-mailing",
    component: () => import("./pages/mass-mailing/MassMailingStats.page.vue"),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: "/mailing-logs",
    name: "mailing-logs",
    component: () => import("./pages/mailing-logs/MailingLogs.page.vue"),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: "/mass-mailing/send",
    name: "mass-mailing-send",
    component: () => import("./pages/mass-mailing/MassMailing.page.vue"),
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/sg-library",
    name: "sg-library",
    component: () => import("./pages/sg-library/SgLibrary.page.vue"),
    meta: {
      middleware: [auth],
    },
  },
  // Declared before the :id route so "create" is never read as a lesson id.
  {
    path: "/sg-library/lesson/create",
    name: "sg-library-lesson-create",
    component: () => import("./pages/sg-library/LessonEditor.page.vue"),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: "/sg-library/lesson/:id",
    name: "sg-library-lesson-edit",
    component: () => import("./pages/sg-library/LessonEditor.page.vue"),
    meta: {
      middleware: [auth],
    },
  },
  // Declared before the :id route so "create" is never read as a drill id.
  {
    path: "/sg-library/drill/create",
    name: "sg-library-drill-create",
    component: () => import("./pages/default-exercise/CreateExercise.page.vue"),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: "/sg-library/drill/:id",
    name: "sg-library-drill-edit",
    component: () => import("./pages/default-exercise/EditExercise.page.vue"),
    meta: {
      middleware: [auth],
    },
  },

  // The addresses this section had before it was the SG Library. Kept as redirects rather than
  // dropped: they are in bookmarks, and every drill link the panel has ever put in a toast or a
  // dialog was one of them. `redirect` carries the params, so an old edit link still opens its
  // own drill rather than the list.
  {
    path: "/default-exercise",
    redirect: { name: "sg-library" },
  },
  {
    path: "/default-exercise/create",
    redirect: { name: "sg-library-drill-create" },
  },
  {
    path: "/default-exercise/edit/:id",
    redirect: (to) => ({ name: "sg-library-drill-edit", params: { id: to.params.id } }),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next();
  }
  const middleware = to.meta.middleware;
  const context = {
    to,
    from,
    next,
    store,
  };
  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1),
  });
});

export default router;
